import { useState, useRef, useEffect } from "react"
import { Link, useNavigate } from "react-router-dom"
import { useAtom } from "jotai"
import {
  isGuideAdminAtom,
  isGuideAtom,
  isOrgAdminAtom,
  isSuperAdminAtom,
  userAtom,
} from "../../state"
import api from "../../services/api"

const UserMenu = () => {
  const [user, setUser] = useAtom(userAtom)
  const [isSuperAdmin] = useAtom(isSuperAdminAtom)
  const [isGuideAdmin] = useAtom(isGuideAdminAtom)
  const [isGuide] = useAtom(isGuideAtom)
  const [isOrgAdmin] = useAtom(isOrgAdminAtom)
const [isOpen, setIsOpen] = useState(false)
  const menuRef = useRef(null)

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])

  const handleLogout = () => {
    api.logout()
      .then(() => {
        setUser(null)
        const bc = new BroadcastChannel("auth")
        bc.postMessage({ type: "logged_out" })
        bc.close()
        window.location.href = "/login"
      })
      .catch((error) => {
        console.error("Logout failed:", error)
      })
  }

  if (!user) return null

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 rounded-lg px-3 py-2 transition-colors hover:bg-gray-100"
      >
        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-brand font-semibold text-white">
          {(user.first_name?.[0] || user.name?.[0] || "U").toUpperCase()}
        </div>
        <span className="hidden text-sm font-medium text-gray-700 md:block">
          {user.first_name || user.name}
        </span>
        <i
          className={`fa fa-chevron-down text-xs text-gray-500 transition-transform ${isOpen ? "rotate-180" : ""}`}
        ></i>
      </button>

      {isOpen && (
        <div className="absolute right-0 z-50 mt-2 w-56 rounded-lg border border-gray-200 bg-white py-2 shadow-lg">
          <div className="border-b border-gray-100 px-4 py-2">
            <p className="text-sm font-semibold text-gray-900">{user.name}</p>
            <p className="text-xs text-gray-500">{user.email}</p>
          </div>

          <div className="py-1">
            <Link
              to="/plan"
              onClick={() => setIsOpen(false)}
              className="flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
            >
              <i className="fa fa-compass w-4"></i>
              <span>View My Plans</span>
            </Link>

            {(isOrgAdmin || isSuperAdmin || isGuideAdmin || isGuide) ? (
              <>
                <Link
                  to="/admin"
                  onClick={() => setIsOpen(false)}
                  className="flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
                >
                  <i className="fa fa-chart-line w-4"></i>
                  <span>{(isGuideAdmin || isGuide) ? "Guide" : "Admin"} Dashboard</span>
                </Link>
              </>
            ) : null}
          </div>

          <div className="border-t border-gray-100 py-1">
            <button
              onClick={handleLogout}
              className="flex w-full items-center gap-3 px-4 py-2 text-sm text-red-600 hover:bg-red-50"
            >
              <i className="fa fa-sign-out w-4"></i>
              <span>Logout</span>
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default UserMenu
